// extracted by mini-css-extract-plugin
export default {"success":"ypJXvtCj","mobile":"mobile","link":"T94hzfTk"};